
  import React, { useContext, useEffect } from 'react'
  import { ToastContainer, toast } from 'react-toastify';
  import { isMobile } from 'react-device-detect';
  import 'react-toastify/dist/ReactToastify.css';
import { AlertContext } from './context/AlertContext';
const Alert = () => {
    const { openAlert } = useContext(AlertContext);
    const { getAlert } = useContext(AlertContext);
    const notify = () => toast.error(`You can view only ${isMobile?2:4} datasets at one time`, {
        position: "bottom-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
    });
    useEffect(() => {
        if (openAlert == true) {
            notify()
            getAlert(false)
        }
    },[openAlert])
    return (
      <div>
        <ToastContainer
            position="bottom-left"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="dark"
/>
      </div>
    );
  }
  
  export default Alert